/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

var datePickerDefaultProps = {
  allowInput: false,
  clearable: false,
  defaultTime: "00:00:00",
  enableTimePicker: false,
  format: void 0,
  mode: "date",
  placeholder: void 0,
  presetsPlacement: "bottom",
  status: "default",
  defaultValue: ""
};
var dateRangePickerDefaultProps = {
  allowInput: false,
  clearable: false,
  defaultTime: ["00:00:00", "23:59:59"],
  enableTimePicker: false,
  mode: "date",
  panelPreselection: true,
  presetsPlacement: "bottom",
  status: "default",
  defaultValue: []
};
var datePickerPanelDefaultProps = {
  defaultTime: "00:00:00"
};
var dateRangePickerPanelDefaultProps = {
  defaultTime: ["00:00:00", "23:59:59"]
};

export { datePickerDefaultProps, datePickerPanelDefaultProps, dateRangePickerDefaultProps, dateRangePickerPanelDefaultProps };
//# sourceMappingURL=defaultProps.js.map
